import store from '../store/index.js';

// Route guards for the new pay-first Message IQ signup flow.
// Entirely separate from productRegGuard.js / smartRampRegGuard.js.

const withQuery = (path, to) => ({ path, query: to.query });

export const messageIqPaymentGuard = (to, from, next) => {
    const state = store.state.messageIqSignup;

    if (!state.plan) {
        return next(withQuery('/signup/message-iq', to));
    }

    return next();
};

export const messageIqPostPaymentGuard = (to, from, next) => {
    const state = store.state.messageIqSignup;

    if (!state.signupToken) {
        return next(withQuery('/signup/message-iq/payment', to));
    }

    return next();
};
